export class Sections {
  Section: SectionInfo[] = [];

  constructor() {}
}
export class SectionInfo {
  UniqueID: string = '';
  ParentID: string = '';
  TemplateID: string = '';
  Title: string = '';
  DisplayTitle: boolean = false;
  Description: string = '';
  Content: string = '';
  ContentType: string = '';
  DisplayType: string = 'One';
  Sequence: number = 0;
  DateCreated: Date = new Date();
  LastUpdated: Date | null = null;
  CreatedBy: any = {};
  UpdatedBy: any = {};
  Fields: FormQuestions[] = [];
  Sections: SectionInfo[] = [];
  IsMappingExists: boolean = false;
  constructor() {}
}

export class FormQuestions {
  Length: number | null = null;
  MaxChar: number | null = null;
  MinChar: number | null = null;
  MaxPeriod?: number | null = null;
  MinPeriod?: number | null = null;
  Expression: number = 0;
  Name: string = '';
  UniqueID: string = '';
  Type: string = '';
  Label: string = '';
  HelpContent: string = '';
  GuidanceText: string = '';
  DisplayHelp: boolean = false;
  DisplayTitle: boolean = false;
  Required: boolean = false;
  IsMappable: boolean = false;
  FieldType: string = '';
  Encrypted: boolean = false;
  IsInUsed: boolean = false;
  UsedIn: string | null = null;
  DefaultValue: any = null;
  DefaultType: any = null;
  AllowOverride: boolean = false;
  IsMappingExists: boolean = false;
  AllowScoring: boolean = false;
  Score: number = 0;
  DisplayOrder: number = 0;
  Options: OptionValues[] = [];
  isShortText: boolean = false;
  QuestionHtml: any;
  AnswerHtml: any;
  GuidanceHtml: any;

  constructor() {}
}

export class OptionValues {
  UniqueID: string = '';
  OptionText: string = '';
  OptionValue: string = '';
  Score: string = '';
}
